/**
 * @generated SignedSource<<cb82524fb604900198c14c22d5790e47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RespondentFilterUsingMetaGroups_questionnaire$data = {
  readonly originalId: string;
  readonly questions: ReadonlyArray<{
    readonly isHidden: boolean | null | undefined;
    readonly isMeta: boolean | null | undefined;
    readonly originalId: string;
    readonly responseScaleId: string | null | undefined;
    readonly shortForm: string | null | undefined;
    readonly tags: ReadonlyArray<string>;
  }>;
  readonly responseScales: ReadonlyArray<{
    readonly originalId: string;
    readonly responseOptions: ReadonlyArray<{
      readonly label: string | null | undefined;
      readonly value: number;
    }>;
  }>;
  readonly " $fragmentType": "RespondentFilterUsingMetaGroups_questionnaire";
};
export type RespondentFilterUsingMetaGroups_questionnaire$key = {
  readonly " $data"?: RespondentFilterUsingMetaGroups_questionnaire$data;
  readonly " $fragmentSpreads": FragmentRefs<"RespondentFilterUsingMetaGroups_questionnaire">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondentFilterUsingMetaGroups_questionnaire",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Question",
      "kind": "LinkedField",
      "name": "questions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMeta",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortForm",
          "storageKey": null
        },
        {
          "alias": "responseScaleId",
          "args": null,
          "kind": "ScalarField",
          "name": "originalResponseScaleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHidden",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponseScale",
      "kind": "LinkedField",
      "name": "responseScales",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ResponseOption",
          "kind": "LinkedField",
          "name": "responseOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuestionnaireInterface",
  "abstractKey": "__isQuestionnaireInterface"
};
})();

(node as any).hash = "e27c0b92bb88a7448b34c9e304c47070";

export default node;
